// components/CustomPieChart.jsx
import React from 'react';

const sampleChartData = [
    { category: 'Coaching Categories', value: 35, color: '#FF6B6B' },
    { category: 'Common Questions', value: 25, color: '#4ECDC4' },
    { category: 'ARI Instructions', value: 20, color: '#45B7D1' },
    { category: 'Subscribers', value: 12, color: '#96CEB4' },
    { category: 'Administrators', value: 8, color: '#FFEAA7' }
];

const CustomPieChart = () => {
    const total = sampleChartData.reduce((sum, item) => sum + item.value, 0);
    let currentAngle = 0;

    const getPieSegments = () => {
        return sampleChartData.map((item, index) => {
            const angle = (item.value / total) * 360;
            const startAngle = currentAngle;
            const endAngle = currentAngle + angle;
            currentAngle += angle;
            
            const startRad = (startAngle - 90) * (Math.PI / 180);
            const endRad = (endAngle - 90) * (Math.PI / 180);
            
            const x1 = 50 + 40 * Math.cos(startRad);
            const y1 = 50 + 40 * Math.sin(startRad);
            const x2 = 50 + 40 * Math.cos(endRad);
            const y2 = 50 + 40 * Math.sin(endRad);
            
            const largeArcFlag = angle > 180 ? 1 : 0;
            
            const pathData = `M 50 50 L ${x1} ${y1} A 40 40 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
            
            return (
                <path
                    key={index}
                    d={pathData}
                    fill={item.color}
                    stroke="white"
                    strokeWidth="2"
                    className="dbmm-pie-segment"
                >
                    <title>{`${item.category}: ${item.value}%`}</title>
                </path>
            );
        });
    };

    return (
        <div className="dbmm-pie-chart-container">
            <h3 className="dbmm-section-title">Website Statistics</h3>
            <div className="dbmm-chart-wrapper">
                <svg viewBox="0 0 100 100" className="dbmm-pie-svg">
                    {getPieSegments()}
                    <circle cx="50" cy="50" r="25" fill="white" className="dbmm-pie-center" />
                </svg>
                <div className="dbmm-chart-legend">
                    {sampleChartData.map((item, index) => (
                        <div key={index} className="dbmm-legend-item">
                            <span className="dbmm-legend-color" style={{ backgroundColor: item.color }}></span>
                            <span className="dbmm-legend-label">{item.category}</span>
                            <span className="dbmm-legend-value">{item.value}%</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CustomPieChart;